import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect, useState } from 'react';
import { getMobileMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { getTBSuiteProductForProductLevelSelector } from '../../../selectors/ProductsSelectors';
import { BaseCardBadge } from '../../../v2/components/merch-card/BaseCardBadge';
import { SUITE_CARD } from '../../../v2/constants/tracking/TrackingSources';
import { useBadges } from '../../../v2/hooks/badges/useBadges';
import { isValidApiName } from '../../../v2/utils/typeguards';
import { CreditsCallout } from '../../common/credits-callout/CreditsCallout';
import MobileMerchCardSelectorButtons from '../../mobile/MobileMerchCardSelectorButtons';
import MobileSuiteFeatureTable from '../../mobile/MobileSuiteFeatureTable';
import MobileCardWrapper from '../../mobile/containers/MobileCardWrapper';
import { FreeCard } from '../cards/FreeCard';
import { StandardSuiteCard } from '../cards/suite/StandardSuiteCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileSuiteCardContainer = ({
  screen
}) => {
  var _badges$productToShow;
  const isAppReady = useGlobalLoading();
  const productLevelsToShow = getMobileMerchCardsToShow('CRM_SUITE');
  const [selectedProductLevel, setSelectedProductLevel] = useState(productLevelsToShow[0]);
  const productToShow = useAppSelector(state => {
    var _product$apiName;
    if (selectedProductLevel === 'FREE') {
      return 'hubspot-free';
    }
    if (!isAppReady) {
      return null;
    }
    const product = getTBSuiteProductForProductLevelSelector(state, {
      suiteProductLevel: selectedProductLevel
    });
    return (_product$apiName = product === null || product === void 0 ? void 0 : product.apiName) !== null && _product$apiName !== void 0 ? _product$apiName : null;
  });
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: productToShow ? [productToShow] : []
  });
  useEffect(() => {
    if (!productLevelsToShow.includes(selectedProductLevel)) {
      setSelectedProductLevel(productLevelsToShow[0]);
    }
  }, [productLevelsToShow, selectedProductLevel]);
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginInline: "auto",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(MobileMerchCardSelectorButtons, {
        options: productLevelsToShow,
        selectedOption: selectedProductLevel,
        onClick: setSelectedProductLevel
      }), /*#__PURE__*/_jsx(MobileCardWrapper, {
        hasBadge: hasBadgeOnFirstColumn || hasBadgeOnLastColumn,
        children: selectedProductLevel === 'FREE' ? /*#__PURE__*/_jsx(FreeCard, {
          productLine: "crm",
          columnStart: 1,
          trackingSource: SUITE_CARD
        }) : /*#__PURE__*/_jsx(StandardSuiteCard, {
          productLevel: selectedProductLevel,
          screen: screen,
          columnStart: 1,
          Badge: productToShow ? /*#__PURE__*/_jsx(BaseCardBadge, {
            apiName: productToShow,
            badgeName: badges === null || badges === void 0 || (_badges$productToShow = badges[productToShow]) === null || _badges$productToShow === void 0 ? void 0 : _badges$productToShow.badgeName
          }) : undefined
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlock: "800",
        children: /*#__PURE__*/_jsx(CreditsCallout, {
          navItem: screen
        })
      }), isValidApiName(productToShow) && /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
        productApiName: productToShow,
        screen: screen
      })]
    })
  });
};